
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24","id":"Pencil-Write-3--Streamline-Streamline--3.0.svg"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Pencil Write 3 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('pencil-write-3')]),_c('path',{attrs:{"d":"M12.712 16.386 9 16.916l0.53 -3.716 9.546 -9.546a2.25 2.25 0 1 1 3.182 3.186Z","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.25 15h-3a1.5 1.5 0 0 0 -1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5 -1.5v-3a1.5 1.5 0 0 0 -1.5 -1.5h-3","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    